import { api_GET } from "./_api.js";

const mapaDeSupressoes_api = {
    mapaDeSupressoes: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("MapaDeSupressoes/")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default mapaDeSupressoes_api;
